import { render, staticRenderFns } from "./docx_generator.vue?vue&type=template&id=ad1035d8"
import script from "./docx_generator.vue?vue&type=script&lang=js"
export * from "./docx_generator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports